import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "عداد الكلمات والأحرف- احسب عدد الكلمات والأحرف في نص";
const DESCRIPTION =
  "احسب عدد الكلمات والأحرف في جملة معينة باستخدام هذه الحاسبة البسيطة. توفر هذه الحاسبة وسيلة سريعة ودقيقة لمعرفة عدد الكلمات والأحرف في أي نص تكتبه.";
const KEYWORDS = "حاسبة, عدد, كلمات, نص, جملة, حساب، أحرف، عدد كلمات، عدد أحرف";
const OG_URL = "https://do-calculate.com/calculator/ar/word-counter/";
function WordCounter() {
  const [sentence, setSentence] = useState("");
  const [wordCount, setWordCount] = useState(null);
  const [charCount, setCharCount] = useState(0);
  const [letterCount, setLetterCount] = useState(0);
  const [error, setError] = useState("");
  const calculateWordCount = () => {
    try {
      if (sentence.trim() === "") {
        setError("الرجاء إدخال جملة لحساب عدد الكلمات");
        return;
      }
      setCharCount(sentence.length);
      setLetterCount(sentence.replace(/\s+/g, "").length);
      const words = sentence.trim().split(/\s+/).length;
      setWordCount(words);
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  توفر هذه الحاسبة وسيلة بسيطة وسريعة لحساب عدد الكلمات في جملة
                  أو نص معين. معرفة عدد الكلمات يمكن أن يكون مفيدًا في عدة
                  سياقات، مثل تحديد عدد الكلمات في مقالة، تحقيق متطلبات الكتابة،
                  أو حتى في تحسين مهارات الكتابة الخاصة بك. يمكن استخدام هذه
                  الأداة لمساعدتك في تقدير حجم النصوص وتخطيط محتوى الكتابة
                  بطريقة أكثر دقة.
                </p>
                <p>
                  على سبيل المثال، إذا كنت تقوم بكتابة مقالة وتحتاج إلى التأكد
                  من أنها تحتوي على عدد معين من الكلمات، يمكنك إدخال النص في هذه
                  الحاسبة لمعرفة العدد الإجمالي للكلمات. يمكن أن يساعدك هذا في
                  التحقق من مدى التزامك بمتطلبات الكتابة أو حتى في تحليل النصوص
                  لتحديد مدى كثافتها.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div className="p-3">
                  <div className="form-group d-flex align-items-center">
                    <label htmlFor="sentence">ادخل الجملة:</label>
                    <textarea
                      id="sentence"
                      value={sentence}
                      onChange={(e) => setSentence(e.target.value)}
                      className="form-control"
                      style={{ width: "75%", height: "100px" }}
                    />
                  </div>
                  <br />
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px", marginLeft: "10px" }}
                    onClick={calculateWordCount}
                  >
                    احسب                  </button>
                </div>
                { error !== "" ? (
                  <p className="p-3 mb-2 bg-warning text-white">خطأ: {error}</p>
                ) : (
                  wordCount !== null && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <p>عدد الكلمات: {wordCount}</p>
                      <p>عدد الأحرف مع مسافات: {charCount}</p>
                      <p>عدد الأحرف بدون مسافات: {letterCount}</p>
                    </div>
                  )
                )}
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">كيفية حساب عدد الكلمات</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>الخطوة 1: إدخال النص</h2>
                  </u>
                  <p>
                    في البداية، تحتاج إلى إدخال الجملة أو النص الذي ترغب في حساب
                    عدد الكلمات فيه. تأكد من إدخال النص بشكل كامل ودقيق للحصول
                    على حساب صحيح. يمكنك إدخال النص في حقل النص المتاح في
                    الحاسبة. هذه الخطوة ضرورية لأن الحساب يعتمد على النص الذي
                    تقوم بإدخاله.
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>الخطوة 2: بدء الحساب</h2>
                  </u>
                  <p>
                    بعد إدخال النص، اضغط على زر "احسب" لبدء عملية الحساب. ستقوم
                    الحاسبة بتحليل النص وتحديد عدد الكلمات الموجودة فيه بناءً
                    على تقسيم النص إلى كلمات باستخدام الفواصل والمسافات. تأكد من
                    عدم وجود نصوص إضافية غير ضرورية لضمان دقة الحساب.
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>الخطوة 3: عرض النتيجة</h2>
                  </u>
                  <p>
                    بعد إتمام الحساب، ستعرض لك الحاسبة عدد الكلمات في النص الذي
                    قمت بإدخاله. يمكنك استخدام هذه المعلومة للتحقق من مدى
                    التزامك بالمتطلبات المحددة لعدد الكلمات، أو لتحليل نصوصك
                    بشكل أكثر دقة. إن معرفة عدد الكلمات يمكن أن يساعدك في تحسين
                    مهارات الكتابة الخاصة بك وتحديد مدى شمولية النص.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black ">
                    مثال: إذا أدخلت النص "مرحبا، كيف حالك اليوم؟" ستظهر لك
                    الحاسبة أن عدد الكلمات هو 4 كلمات.
                  </div>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      الخطوة 4: استخدام عدد الكلمات
                    </h2>
                  </u>
                  <p>
                    بعد معرفة عدد الكلمات، يمكنك استخدام هذه المعلومة لأغراض
                    متعددة مثل تنظيم المحتوى، التحقق من الالتزام بمتطلبات
                    الكتابة، أو تحسين النصوص. يمكن أن تكون هذه الأداة مفيدة في
                    كتابة المقالات، إعداد التقارير، أو أي نصوص أخرى تتطلب تتبعًا
                    دقيقًا لعدد الكلمات.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black ">
                    مثال: إذا كنت تكتب مقالاً وتحتاج إلى تحديد عدد الكلمات فيه
                    لضمان توافقه مع متطلبات النشر، يمكنك استخدام الحاسبة لمعرفة
                    العدد النهائي.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default WordCounter;
